import { CartButton } from "@src/components"
import { ProductCart, getSliceSubdomain } from "@src/lib"
import Share from "@src/components/icons/Share"
import { useSliceContext } from "@src/components/SliceProvider"
import MarkdownBlock from "@src/components/ui/MarkdownBlock"
import { zeroAddress } from "viem"
import { Button } from "@src/components/ui/base/button"
import ProductDefault from "@src/public/product_default.png"
import { useState } from "react"
import { copyText } from "@src/lib/copyText"
import { formatBlockscanUrl } from "@src/lib/formatBlockscanUrl"
import { shortenAddress } from "@src/lib/shortenAddress"
import DisplayPrice from "@/src/components/DisplayPrice"

export const PRODUCT_VIEW = (params: { product: ProductCart }) => {
  const { product } = params
  const { appChainId } = useSliceContext()
  const {
    slicerId,
    shortDescription,
    description,
    productId,
    name,
    externalAddress: externalPriceAddress,
    image,
    path
  } = product
  const [isCopied, setIsCopied] = useState(false)

  const displayedImage = image || ProductDefault

  return (
    <>
      <Button
        variant="ghost"
        className="sl-absolute sl-top-[24px] sl-left-[24px] sl-flex sl-items-center"
        onClick={async () =>
          await copyText(
            `https://${getSliceSubdomain(appChainId)}slice.so/slicer/${
              path || slicerId
            }?product=${productId}`,
            setIsCopied
          )
        }
      >
        <Share className="sl-w-5 sl-h-5" />
        <p className="sl-text-sm sl-font-medium">
          {isCopied ? "Link copied!" : "Share"}
        </p>
      </Button>
      <div className="sl-pb-10 sl-text-center">
        <h1 className="sl-fonts">{name}</h1>
        {shortDescription && (
          <p className="sl-max-w-sm sl-mt-4 sl-mx-auto sl-text-muted-foreground">
            {shortDescription}
          </p>
        )}
      </div>
      <div className="sl-space-y-8">
        <div className="sl-w-[240px] sl-h-[240px] sl-mx-auto">
          <img
            src={displayedImage}
            alt={name}
            className="sl-bg-gradient-to-br sl-aspect-square sl-object-cover sl-from-gray-900 sl-to-gray-700 sl-rounded-xl sl-col-span-1 sl-max-w-[240px]"
          />
        </div>

        {description && (
          <div className="sm:sl-px-6">
            <MarkdownBlock content={description} />{" "}
          </div>
        )}

        <div className="sl-space-y-4">
          <div className="sl-flex sl-justify-center">
            <CartButton productId={productId} size="lg" />
          </div>
          <div className="sl-flex sl-justify-center">
            <DisplayPrice product={product} isFlex={false} />
          </div>
        </div>
        {externalPriceAddress != "0x00000000" &&
          externalPriceAddress != zeroAddress && (
            <p className="sl-mx-auto sl-text-sm sl-text-center sl-text-muted-foreground/80">
              Price dynamically calculated from{" "}
              <a
                className="sl-highlight"
                href={formatBlockscanUrl(appChainId, externalPriceAddress)}
                target="_blank"
                rel="noopener noreferrer"
              >
                {shortenAddress(externalPriceAddress)}
              </a>
              {/* {strategy && ` (${strategy.label})`} */}
            </p>
          )}
        {/* TODO: Enable */}
        {/* {extAddress &&
        extAddress != "0x00000000" &&
        extAddress != zeroAddress &&
        (extValue != "0" || extExecSig != "0x00000000") && (
          <p className="sl-pt-4 sl-mx-auto sl-text-sm sl-text-center sl-text-muted-foreground">
            Interacts with{" "}
            <a
              className="sl-font-bold sl-highlight"
              href={formatBlockscanUrl(extAddress)}
              target="_blank"
              rel="noopener noreferrer"
            >
              {extAddress.replace(
                extAddress.substring(5, extAddress.length - 3),
                `\xa0\xa0\xa0\xa0\xa0\xa0`
              )}
            </a>{" "}
            by{" "}
            {extValue != "0" && (
              <>
                sending{" "}
                <b>
                  {currency.toLowerCase() ===
                  availableCurrencies[0].value.toLowerCase()
                    ? `${
                        Math.round(
                          Number(
                            formatEther(
                              externalPriceAddress
                                ? (BigInt(price || 0) * BigInt(extValue)) /
                                    BigInt(1e4)
                                : BigInt(extValue)
                            )
                          ) * 1e4
                        ) / 1e4
                      } ETH`
                    : `${formatNumber(
                        externalPriceAddress
                          ? Math.round(
                              Number(BigInt(price) * BigInt(extValue)) / 1e8
                            ) / 100
                          : extValue
                      )} USDC`}
                </b>
              </>
            )}
            {extValue != "0" && extExecSig != "0x00000000" ? " and " : ""}
            {extExecSig != "0x00000000" ? (
              <>
                executing <b>{getFunctionFromSelector(extExecSig)}</b>
              </>
            ) : (
              ""
            )}
          </p>
        )} */}
        {/* {purchaseElArray && purchaseElArray.length != 0 ? (
          <p className="pt-4 text-muted-foreground text-sm text-center mx-auto max-w-[340px]">
            Contains <b>{purchaseEl}</b>
          </p>
        ) : null} */}
      </div>
    </>
  )
}

export default PRODUCT_VIEW
